import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import ServiceHistoryOverviewCard from './ServiceHistoryOverviewCard';

const ServiceHistoryOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:verification.service_history_request.overview.meta.title')} />
      <ServiceHistoryOverviewCard />
    </ContentLayout>
  );
};

export default ServiceHistoryOverviewPage;
